import { Typography } from "@mui/material";
import { BaseModuleSubtype } from "../../../../../../types/actionModule/subtypes/subtype";
import { TextAnswerSubtypeDataModel } from "../../../../../../types/actionModule/subtypes/textAnswerSubtype";

interface Props {
    subtype: BaseModuleSubtype;
    subtypeData: TextAnswerSubtypeDataModel;
}

export default function TextAnswerSubtypeSummary(props: Props) {
    return <Typography sx={{ textOverflow: "ellipsis" }}>{props.subtypeData.textAnswer}</Typography>
}
